(() => {
  const root = document.getElementById('ssp-feedback-survey');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  const dialog = root.querySelector('dialog');
  const frame = root.querySelector('iframe');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const formUrl = root.dataset.formUrl;
  if (!/^https:\/\/form\.jotform\.com\/\d+$/.test(formUrl)) return;
  if (/\/(cart|checkout|checkouts|account)(\/|$)/.test(location.pathname)) return;
  const delay = Math.max(60000, Number(root.dataset.delaySeconds || 300) * 1000);
  const cooldown = Math.max(1, Number(root.dataset.cooldownDays || 30)) * 86400000;
  const sessionKey = 'ssp_feedback_v1_session';
  const cooldownKey = 'ssp_feedback_v1_last_shown';
  let elapsed = 0, shown = false, privacyReady = false, preferencesAllowed = false, restored = false;
  let lastTick = performance.now(), focusBefore = null, timer;
  const read = (kind, key) => { try { return window[kind].getItem(key); } catch { return null; } };
  const write = (kind, key, value) => { try { window[kind].setItem(key, value); } catch {} };
  const persist = () => {
    if (preferencesAllowed) write('sessionStorage', sessionKey, JSON.stringify({elapsed, shown}));
  };
  const analyticsAllowed = () => privacyReady && window.Shopify.customerPrivacy.analyticsProcessingAllowed();
  const refreshPrivacy = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    privacyReady = Boolean(privacy && typeof privacy.analyticsProcessingAllowed === 'function');
    preferencesAllowed = Boolean(privacyReady && privacy.preferencesProcessingAllowed());
    if (preferencesAllowed && !restored) {
      restored = true;
      try {
        const state = JSON.parse(read('sessionStorage', sessionKey) || '{}');
        if (Number.isFinite(state.elapsed)) elapsed = Math.max(elapsed, Math.min(state.elapsed, delay));
        shown = shown || state.shown === true;
      } catch {}
    }
    if (privacyReady && !analyticsAllowed() && dialog.open) { dialog.close(); frame.removeAttribute('src'); }
  };
  const suppressed = () => {
    if (shown) return true;
    if (!preferencesAllowed) return false;
    const lastShown = Number(read('localStorage', cooldownKey) || 0);
    return lastShown > 0 && Date.now() - lastShown < cooldown;
  };
  const busy = () => {
    const active = document.activeElement;
    if (active && (active.matches('input, textarea, select') || active.isContentEditable)) return true;
    return [...document.querySelectorAll('dialog[open], [aria-modal="true"]')]
      .some(element => element !== dialog && element.getClientRects().length > 0);
  };
  const open = (preview = false) => {
    if (document.hidden || !analyticsAllowed() || (!preview && (suppressed() || busy()))) return false;
    focusBefore = document.activeElement;
    frame.src = formUrl;
    dialog.showModal();
    if (!preview) {
      shown = true; persist();
      if (preferencesAllowed) write('localStorage', cooldownKey, String(Date.now()));
      clearInterval(timer);
    }
    return true;
  };
  const tick = () => {
    const now = performance.now(), delta = Math.max(0, Math.min(now - lastTick, 2000));
    lastTick = now;
    if (!document.hidden && !shown) elapsed = Math.min(delay, elapsed + delta);
    persist();
    if (elapsed >= delay) open();
  };
  root.querySelector('.ssp-feedback-close').addEventListener('click', () => dialog.close());
  root.querySelector('.ssp-feedback-skip').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target === dialog) {
      const b = dialog.getBoundingClientRect();
      if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) dialog.close();
    }
  });
  dialog.addEventListener('close', () => {
    frame.removeAttribute('src');
    if (focusBefore && focusBefore.isConnected) focusBefore.focus();
  });
  document.addEventListener('visibilitychange', () => { lastTick = performance.now(); persist(); });
  window.addEventListener('pagehide', persist);
  window.addEventListener('storage', event => {
    if (event.key === cooldownKey && event.newValue && dialog.open) dialog.close();
  });
  document.addEventListener('visitorConsentCollected', refreshPrivacy);
  const previewButton = root.querySelector('.ssp-feedback-preview');
  if (previewButton) previewButton.addEventListener('click', () => open(true));
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
      if (!error) refreshPrivacy();
    });
  }
  refreshPrivacy();
  if (!(window.Shopify && window.Shopify.designMode)) timer = setInterval(tick, 1000);
})();
